import { textXs } from '@insify/design-system/typography';
import { RequestSaveQuoteEmail, TrustpilotStars } from '@insify/funnel-components';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useCommands } from '../../../../hooks/useCommands';
import { useParamsQuery } from '../../../../hooks/useQueries';

import * as styles from './BelowSubmit.module.css';

import type { RiskCarrier } from '../../../../models/queries';

type Props = {
  className?: string;
  riskCarrier?: RiskCarrier;
};

export const BelowSubmit: React.FC<Props> = ({ riskCarrier }) => {
  const { t } = useTranslation(['funnel', 'common', 'validation']);
  const { sendCommand } = useCommands();
  const { data } = useParamsQuery();
  return (
    <div className={styles.wrapper}>
      <RequestSaveQuoteEmail
        email={data?.representative?.email ?? ''}
        onSubmitForm={async ({ email }) => {
          return await sendCommand({
            type: 'requestSaveQuoteEmail',
            payload: {
              email,
            },
          });
        }}
        translations={{
          close: t('common:close'),
          required: t('validation:required'),
          emailInvalid: t('validation:email_invalid'),
          saveQuoteEmailButton: t('funnel:coverage_request_save_quote_email_button'),
          saveQuoteEmailModalSubmitTitle: t('funnel:coverage_request_save_quote_modal_submit_title'),
          saveQuoteEmailModalSubmitLabel: t('funnel:coverage_request_save_quote_modal_submit_label'),
          saveQuoteEmailModalSubmitButton: t('funnel:coverage_request_save_quote_modal_submit_button'),
        }}
      />
      <TrustpilotStars className={styles.trustpilot} locale='fr' kind='horizontal' height='24px' width='100%' />
      {riskCarrier && (
        <p className={clsx(textXs, styles.riskCarrier)}>
          {t('funnel:coverage_receipt_risk_carrier', { riskCarrier: t(`funnel:risk_carrier_${riskCarrier}`) })}
        </p>
      )}
    </div>
  );
};
